import { axios } from "Config/ApiConfig";
import { dispatchItemToRedux } from "./CommonActions";
import ReducerTypes from "Redux/Types/ReducerTypes";
import API from "Constants/Apis";
import { toast } from "react-toastify";

export function getBlogActions(page = 1) {
  return async (dispatch) => {
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.TOGGLE_LOADING,
        payload: {},
      })
    );
    try {
      const { data } = await axios({
        method: "GET",
        _addToken: false,
        url: "posts?for=for_website",
        params: { page },
      });
      if (data.status === 200) {
        const items = data?.data?.data;
        const paginationData = {
          current_page: data.data.current_page,
          last_page: data.data.last_page,
          total: data.data.total,
          per_page: data.data.per_page,
          next_page_url: data.data.next_page_url,
        };

        dispatch(
          dispatchItemToRedux({
            type: ReducerTypes.All_BLOGS,
            payload: {
              items,
              paginationData,
            },
          })
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      dispatch(
        dispatchItemToRedux({
          type: ReducerTypes.TOGGLE_LOADING,
          payload: {},
        })
      );
    }
  };
}

// search
export const getPostSearch = (params) => {
  return function (dispatch) {
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.TOGGLE_LOADING,
        payload: {},
      })
    );
    return new Promise(function (resolve, reject) {
      axios({
        method: "POST",
        url: "/posts?for=for_website",
        _addToken: false,
        data: {
          search: params,
        },
      })
        .then((res) => {
          if (res?.data?.data) {
            const items = res?.data?.data?.data;
            const paginationData = {
              current_page: res.data.data.current_page,
              last_page: res.data.data.last_page,
              total: res.data.data.total,
              per_page: res.data.data.per_page,
              next_page_url: res.data.data.next_page_url,
              first_page_url: res.data.data.first_page_url,
            };
          
            dispatch(
              dispatchItemToRedux({
                type: ReducerTypes.All_BLOGS,
                payload: {
                  items,
                  paginationData,
                },
              })
            );
         
            resolve(true);
          }
        })
        .catch((err) => {
          toast("چنین متنی وجود ندارد", { type: "error" });
          reject(err);
        })
        .finally(() => {
          dispatch(
            dispatchItemToRedux({
              type: ReducerTypes.TOGGLE_LOADING,
              payload: {},
            })
          );
        });
    });
  };
};

// SINGLE PAGE
export function getSingleBlog() {
  return async (dispatch, getState) => {
    const blogId = getState().blog.blogId.id;

    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.TOGGLE_LOADING,
        payload: {},
      })
    );
    try {
      const { data } = await axios({
        method: "GET",
        _addToken: false,
        url: `posts/${blogId}?for=for_website`,
      });
    
      if (data.status === 200) {
        const items = data?.data;

        dispatch(
          dispatchItemToRedux({
            type: ReducerTypes.SINGLE_BLOG,
            payload: items,
          })
        );
      }
    } catch (error) {
      return Promise.reject(error);
    } finally {
      dispatch(
        dispatchItemToRedux({
          type: ReducerTypes.TOGGLE_LOADING,
          payload: {},
        })
      );
    }
  };
}

// add comment
export const insertCommentForPost = async (post_id, message) => {
  try {
    const { data } = await axios({
      method: "POST",
      url: "posts/comment/insert",
      data: {
        post_id,
        message,
      },
    });
    toast(data.message, { type: "success" });
  } catch (err) {
    toast(err, { type: "success" });

    return Promise.reject(err);
  }
};
